
<div class="row">
	<h5 class="title" [ngClass]="{'required': isRequired}" style="margin-bottom: 20px;">{{formTitle}}</h5>
	<app-audioplayer *ngIf="formItem?.item?.allowAudio && formItem?.item?.audioFileName != '' && formItem.item?.audioFileName != null" [formItem]="formItem" [formId]="formId"></app-audioplayer>
</div>

<div class="body">
	<div class="center input-group">
		<div class="option-wrapper">
			<div class="row">
			<canvas id="canvas1" class="canvas" #canvas width="654" height="500" (click)="drawCircle($event)" (change)="updateConditional()"></canvas>
			</div>
			<div class="survey-nav-buttons" >
				<button class="btn btn-lg btn-csc-primary" (click)="clearImage()"><strong>START OVER</strong></button>
        <button class="btn btn-lg btn-csc-primary" (click)="undoLast()"><strong>UNDO</strong></button>
			</div>
		</div>
	</div>
</div>

